import React from 'react'
import Popup from '../Popup'
import './revisions.css'

const RevisionPopup = (props) => <Popup className="revision-popup" {...props} />

export default RevisionPopup
